import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts-more';
import ScaleModal from './ScaleModal';
HighchartsMore(Highcharts);

(function (H) {
  let addEvent = H.addEvent,
    each = H.each,
    doc = document;

  H.wrap(H.Chart.prototype, 'init', function (proceed) {

    proceed.apply(this, Array.prototype.slice.call(arguments, 1));

    let chart = this,
      renderer = chart.renderer,
      yAxis = chart.yAxis;

    each(yAxis, function (yAxis) {
      let options = yAxis.options,
        scalable = options.scalable === undefined ? true : options.scalable,
        labels = options.labels,
        labelGroupBBox,
        bBoxX,
        bBoxY,
        bBoxWidth,
        bBoxHeight;
      if (scalable) {
        bBoxWidth = 40;
        bBoxHeight = 400 - yAxis.top - yAxis.bottom;
        bBoxX = yAxis.opposite ? (labels.align !== 'left' ? chart.containerWidth - yAxis.right : chart.containerWidth - (yAxis.right + bBoxWidth)) : (labels.align === 'left' ? yAxis.left : yAxis.left - bBoxWidth);
        bBoxY = yAxis.top;
        labelGroupBBox = renderer.rect(bBoxX, bBoxY, bBoxWidth, bBoxHeight).attr({
            fill: '#fff',
            opacity: 0,
            zIndex: 8
          }).css({
            cursor: 'ns-resize'
          }).add();
        labels.style.cursor = 'ns-resize';
        addEvent(labelGroupBBox.element, 'dblclick', function () {
          ReactDOM.render(
            <ScaleModal yAxis={yAxis}/>
            , document.getElementById('modalContainer')
          );
        });
      }
    });
  });
}(Highcharts));

class GraphView extends Component {
  constructor(props, context) {
    super(props, context);
    this._component = null;
  }

  // When the DOM is ready, create the chart.
  componentDidMount() {
    // Extend Highcharts with modules
    if (this.props.modules) {
      this.props.modules.forEach(function (module) {
        module(Highcharts);
      });
    }
    // this.makeChart(this.props);
  }

  // componentWillReceiveProps: function (props) {
  //   this.makeChart(props);
  // },

  //Destroy chart before unmount.
  componentWillUnmount() {
    this.chart.destroy();
  }

  makeChart(props, component) {
    // debugger;
    // Set container which the chart should render to.
    this.chart = new Highcharts[props.type || "Chart"](
      component = ReactDOM.findDOMNode(this),
      // this.props.container,
      props.options
    );
  }

  setNMake(component) {
    this.makeChart(this.props, component);
  }

  //Create the div which the chart will be rendered to.
  render() {
    // if (this.chart) {
    //   this.makeChart();
    // }
    return (
      <div>
        <div ref={(c) => c ? this.setNMake(c) : null}>
        </div>
      </div>
    );
  }
}

export default GraphView;



// WEBPACK FOOTER //
// ./src/components/GraphView.js